import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { BACKGROUND_COLOR_BLACK } from '~/src/features/movix-new/constants';

import { Container } from '~/src/features/movix-new/styled';

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: ${BACKGROUND_COLOR_BLACK};
    width: 100%;
    height: fit-content;
    padding-bottom: 94px;
    padding-top: 150px;
    row-gap: 147px;
    margin-top: -1px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        row-gap: 220px;
        padding-bottom: 42px;
        padding-top: 356px;
    }
`;

export const StyledContainer = styled(Container)`
    z-index: 2;
`;

export const CardWrapper = styled.div`
    position: relative;
    width: 100%;
    height: fit-content;
    z-index: 1;

    :before {
        content: '';
        position: absolute;
        bottom: calc(50% - 273.5px);
        right: -20px;
        mix-blend-mode: screen;
        width: 594px;
        height: 547px;
        background: url('/static/images/movix-new/light-min.png') no-repeat center center;
        background-size: contain;
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        :before {
            display: none;
        }
    }
`;

export const Title = styled.div`
    ${FONTS.H2}
    color: ${COLORS.TextWhite};
    text-align: center;
    z-index: 2;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.H3}
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        span {
            display: block;
        }
    }
`;

export const Description = styled.div`
    z-index: 2;
    ${FONTS.M}
    text-align: center;
    color: ${COLORS.TextWhite};
    max-width: 625px;
    margin: 12px 0 32px 0;
    white-space: pre-line;

    #afterConnect {
        display: none;
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.S}
        max-width: 556px;
        #afterConnect {
            display: none;
        }

        #afterDays {
            display: initial;
        }
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.XS}
        max-width: 425px;

        #afterDays {
            display: none;
        }
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS}
        max-width: 425px;

        #afterConnect {
            display: initial;
        }
    }
`;

export const ButtonBlock = styled.div`
    z-index: 2;
    max-width: 252px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: 280px;
    }
`;

export const TextBlock = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 50%;
    margin: 0 auto;
    max-width: 767px;
    padding: 0 13px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;

export const Card = styled.div`
    z-index: 2;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-between;
    width: 100%;
    max-height: 213px;

    padding: 31px;

    :before {
        content: '';
        position: absolute;
        bottom: calc(50% - 273.5px);
        right: 0;
        mix-blend-mode: screen;
        width: 594px;
        height: 547px;
        background-image: url('/static/images/movix-new/light-min.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        padding: 40px 24px 46px 24px;

        :before {
            width: 524px;
            height: 482px;
            bottom: calc(50% - 241px);
            right: -14px;
        }
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 35px;

        :before {
            width: 303px;
            height: 279px;
            bottom: calc(50% - 139.5px);
            right: -8px;
        }
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column-reverse;
        padding: 0;

        :before {
            width: 365px;
            height: 336px;
            bottom: calc(50% + 9px);
            right: -41px;
        }
    }
`;

export const CardTitle = styled.div`
    ${FONTS.H2}
    color: ${COLORS.TextWhite};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.H3}
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        text-align: center;
    }
`;

export const CardDescription = styled.div`
    color: ${COLORS.TextWhite};
    ${FONTS.M};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.XS}
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        text-align: center;
        margin-top: 8px;
    }
`;

export const BGImage = styled.div<{ position: 'right' | 'left', src: string }>`
    position: absolute;
    top: -118px;
    z-index: 0;
    ${({ position }) => {
    switch (position) {
      case 'right':
        return css`
          right: -790px;

          :before {
              content: url('/static/images/movix-new/star-wars-light.png');
              mix-blend-mode: screen;
              position: absolute;
              left: 237px;
              top: 76px;
          }
        `;
      case 'left':
        return css`
          transform: scale(-1, 1);
          left: -790px;

          :before {
              content: url('/static/images/movix-new/corparation-light.png');
              mix-blend-mode: screen;
              position: absolute;
              left: 246px;
              top: 46px;
          }
        `;
    }
  }}
  color: ${COLORS.TextWhite};
    width: 1071px;
    height: 582px;
    background: url(${({ src }) => src}) no-repeat center center;
    background-size: contain;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${({ position }) => {
      switch (position) {
        case 'right':
          return css`right: -743px;`;
        case 'left':
          return css`left: -743px;`;
      }
        }} @media (max-width: ${wideBreakpoints.tablet}) {
        width: 848px;
        height: 461px;
        ${({ position }) => {
      switch (position) {
        case 'right':
          return css`
            right: -545px;

            :before {
              left: 165px;
              top: 4px;
            }
          `;
        case 'left':
          return css`
            left: -545px;

            :before {
              left: 187px;
              top: -26px;
            }
          `;
      }
        }}
    }

        @media (max-width: ${wideBreakpoints.mobile}) {
      ${({ position }) => position === 'right'
              ? css`display: none;`
              : css`
                top: -375px;
                left: -412px;
              `}
      width: 902px;
      height: 490px;

      :before {
        left: 195px;
        top: -9px;
      }
        }
`;

export const CardTextBlock = styled(TextBlock)`
    align-items: flex-start;
    margin: 0;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 60px;
    }
`;

export const CircleLight = styled.div`
    position: absolute;
    width: 2436px;
    height: 2436px;
    background: radial-gradient(33.01% 38.15% at 50.05% 46.07%, rgba(15, 80, 240, .59) 0%, rgba(15, 80, 240, 0) 100%);
    mix-blend-mode: normal;
    opacity: 0.35;
    z-index: 1;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 1684px;
        height: 1684px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 1684px;
        height: 1684px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 1595px;
        height: 2100px;
        background: radial-gradient(33.01% 38.15% at 50.05% 46.07%, rgba(15, 80, 240, .59) 0%, rgba(15, 80, 240, 0) 100%);
    }
`;

export const ImageBlock = styled.div`
    width: 50%;

    img {
        width: 100%;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;
